import React from "react";
import PropTypes from "prop-types";
import { StyledTextItem } from "./_.styled";

const TextItem = ({ label, className }) => (
  <StyledTextItem
    className={className}
    data-testid="list-element"
    dangerouslySetInnerHTML={{ __html: label?.replace(/\s+/g, " ") }}
  />
);

TextItem.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TextItem;
